// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__2MRAE","title":"AfterImages45_title__23-Hd","images":"AfterImages45_images__3HEv3"};